import { useRef, useEffect } from "react";
import { Select, chakraComponents } from "chakra-react-select";
import { Box, Button, Spinner, Text } from "@chakra-ui/react";

const PaginatedSelect = ({
  options,
  value,
  onChange,
  onLoadMore,
  hasMore,
  isLoading,
  label,
  error,
  helperText,
  styles,
  loadMoreContent = "Load More",
  noMoreOptionsContent = "No more options",
  ...selectProps
}) => {
  const menuListRef = useRef(null);
  const firstOpenRef = useRef(false);

  const CustomMenuList = (props) => {
    const handleLoadMore = (e) => {
      firstOpenRef.current = false;
      e.stopPropagation();
      if (menuListRef.current) {
        const currentScrollTop = menuListRef.current.scrollTop;
        setTimeout(() => {
          onLoadMore?.();
          setTimeout(() => {
            if (menuListRef.current) {
              menuListRef.current.scrollTop = currentScrollTop;
            }
          }, 100);
        }, 0);
      }
    };

    useEffect(() => {
      if (
        menuListRef.current &&
        props.selectProps.menuIsOpen &&
        !firstOpenRef.current
      ) {
        menuListRef.current.scrollTop = menuListRef.current.scrollHeight;
      }
    }, [props.selectProps.menuIsOpen]);

    const renderLoadMore = () => {
      if (typeof loadMoreContent === "string") {
        return (
          <Button size="sm" variant="unstyled" onClick={handleLoadMore}>
            {loadMoreContent}
          </Button>
        );
      }
      return <Box onClick={handleLoadMore}>{loadMoreContent}</Box>;
    };

    return (
      <chakraComponents.MenuList {...props} innerRef={menuListRef}>
        {props.children}
        {options.length > 0 && (
          <Box textAlign="center" p={2}>
            {isLoading ? (
              <Spinner size="sm" />
            ) : hasMore ? (
              renderLoadMore()
            ) : (
              <Text color="#CC808080">{noMoreOptionsContent}</Text>
            )}
          </Box>
        )}
      </chakraComponents.MenuList>
    );
  };

  return (
    <Box>
      {label && (
        <Text fontWeight="semibold" mb={1}>
          {label}
        </Text>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={options}
        components={{ ...chakraComponents, MenuList: CustomMenuList }}
        menuPortalTarget={document.body}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          ...styles,
        }}
        onMenuOpen={() => {
          firstOpenRef.current = true;
        }}
        {...selectProps}
      />
      {error && (
        <Text mt={1} color="red.500" fontSize="sm">
          {error}
        </Text>
      )}
      {helperText && !error && (
        <Text mt={1} color="gray.500" fontSize="sm">
          {helperText}
        </Text>
      )}
    </Box>
  );
};

export default PaginatedSelect;
